if (!customElements.get('complete-the-look')) {
  class CompleteTheLook extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('.complete-the-look-block__row'));
      this.totalLine = this.querySelector('[data-total-line]');
      this.formId = this.dataset.productFormId;
      this.form = this.formId ? document.getElementById(this.formId) : null;

      this.rows.forEach((row) => {
        const checkbox = row.querySelector('[data-row-checkbox]');
        const select = row.querySelector('[data-row-select]');

        checkbox.addEventListener('change', () => this.updateTotalLine());

        if (select) {
          select.addEventListener('change', () => {
            this.updateRowPrice(row);
            this.updateTotalLine();
          });
        }
      });

      this.updateTotalLine();

      if (this.form) {
        this.onMainFormSubmit = this.onMainFormSubmit.bind(this);
        this.form.addEventListener('submit', this.onMainFormSubmit);
      }
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this.onMainFormSubmit);
      }
    }

    updateRowPrice(row) {
      const select = row.querySelector('[data-row-select]');
      const priceEl = row.querySelector('[data-row-price]');
      if (!select || !priceEl) return;
      const price = parseInt(select.selectedOptions[0].dataset.price, 10);
      priceEl.textContent = this.formatMoney(price);
    }

    getRowPrice(row) {
      const select = row.querySelector('[data-row-select]');
      if (select) return parseInt(select.selectedOptions[0].dataset.price, 10);
      const checkbox = row.querySelector('[data-row-checkbox]');
      return parseInt(checkbox.dataset.price, 10);
    }

    getRowVariantId(row) {
      const select = row.querySelector('[data-row-select]');
      if (select) return select.value;
      const checkbox = row.querySelector('[data-row-checkbox]');
      return checkbox.dataset.variantId;
    }

    getSelectedItems() {
      const items = [];
      this.rows.forEach((row) => {
        const checkbox = row.querySelector('[data-row-checkbox]');
        if (!checkbox.checked) return;
        items.push({ id: this.getRowVariantId(row), quantity: 1 });
      });
      return items;
    }

    updateTotalLine() {
      if (!this.totalLine) return;

      let total = 0;
      let count = 0;

      this.rows.forEach((row) => {
        const checkbox = row.querySelector('[data-row-checkbox]');
        if (!checkbox.checked) return;
        total += this.getRowPrice(row);
        count += 1;
      });

      this.totalLine.textContent = count
        ? `Kombini tamamla önerisini sepete eklediniz. Fiyata +${this.formatMoney(total)} dahil edildi.`
        : '';
    }

    // Fires when the main product's "Sepete Ekle" form is submitted.
    // We don't touch that submission — Dawn handles the main product itself.
    // We just piggyback a second, silent add-to-cart request for whatever
    // complete-the-look items are checked.
    onMainFormSubmit() {
      const items = this.getSelectedItems();
      if (!items.length) return;

      // Small delay so the main product's own add-to-cart request/UI update
      // resolves first; this request then layers on top of it.
      setTimeout(() => this.addSelectedToCart(items), 500);
    }

    async addSelectedToCart(items) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const payload = { items };
      if (cart) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      try {
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (data.status) {
          throw new Error(data.description || data.message || 'cart add failed');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'complete-the-look', cartData: data });
        }

        if (cart) {
          cart.renderContents(data);
        }
      } catch (error) {
        console.error('[complete-the-look]', error);
      }
    }

    formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme?.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return `${(cents / 100).toFixed(2)} TL`;
    }
  }

  customElements.define('complete-the-look', CompleteTheLook);
}
